import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';
import Select from 'form/Select';

@withRouter

@connect((state, props) => ({
  initialValues: props.site.attributes,
}))

@reduxForm({
  form: 'CacheSettings',
  onSubmit(values, dispatch, props) {
    const { site } = props;

    return dispatch(api.setMaxAges(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: {
            maxAgeHtml: values.maxAgeHtml,
            maxAgeCss: values.maxAgeCss,
            maxAgeJs: values.maxAgeJs,
            maxAgeImages: values.maxAgeImages,
            maxAgeOther: values.maxAgeOther,
          },
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}/settings`);
      dispatch(notice('CacheSettings.success'));
    })
    .catch((response) => {
      dispatch(alert('CacheSettings.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class CacheSettings extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    const cacheOptions = [
      { value: '0', label: 'Do not cache' },
      { value: '180', label: '3 minutes' },
      { value: '1200', label: '20 minutes' },
      { value: '3600', label: '1 hour' },
      { value: '10800', label: '3 hours' },
      { value: '43200', label: '12 hours' },
      { value: '86400', label: '1 day' },
      { value: '259200', label: '3 days' },
      { value: '604800', label: '1 week' },
      { value: '2592000', label: '1 month' },
      { value: '7776000', label: '3 months' },
      { value: '31919000', label: '1 year' },
    ];

    return (
      <div className="Site__area">
        <div className="Site__area__header">
          <div className="Site__area__header__title">
            Cache-Control Headers (max-age)
          </div>
        </div>
        <div className="Site__area__content">
          <Form error={error} onSubmit={handleSubmit}>
            <Field label="Settings.maxAgeHtml" name="maxAgeHtml">
              <Select
                clearable={false}
                options={cacheOptions}
              />
            </Field>
            <Field label="Settings.maxAgeCss" name="maxAgeCss">
              <Select
                clearable={false}
                options={cacheOptions}
              />
            </Field>
            <Field label="Settings.maxAgeJs" name="maxAgeJs">
              <Select
                clearable={false}
                options={cacheOptions}
              />
            </Field>
            <Field label="Settings.maxAgeImages" name="maxAgeImages">
              <Select
                clearable={false}
                options={cacheOptions}
              />
            </Field>
            <Field label="Settings.maxAgeOther" name="maxAgeOther">
              <Select
                clearable={false}
                options={cacheOptions}
              />
            </Field>
            <SubmitButton
              dirty={dirty}
              className="button button--secondary"
              submitting={submitting}
              label="Settings.submit"
            />
          </Form>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/CacheSettings.jsx